import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=639e8634&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=639e8634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e8634",
  null
  
)

export default component.exports